module.exports = __webpack_public_path__ + "static/media/ep4in.1d8eede0.png";